/**
 * @module ol/source/WMTSRequestEncoding
 */
/**
 * Request encoding. One of 'KVP', 'REST'.
 * @enum {string}
 */
export default {
    KVP: 'KVP',
    REST: 'REST' // see spec §10
};
//# sourceMappingURL=WMTSRequestEncoding.js.map